exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "header[data-v-1b27e2e4]{margin:15mm}#main[data-v-1b27e2e4]{margin:5mm 15mm}.clearfix[data-v-1b27e2e4]{clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b27e2e4","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/print/PageContent.vue
// module id = 485
// module chunks = 0